import React from 'react';

function LikeBar(props) {
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-12">
          <span className="icon-text">

            {props.data.likes.includes(localStorage.getItem('user')) ?
              <span className="icon" onClick={() => { props.handleRemoveLike(props.data) }}>
                <i className="fas fa-thumbs-up" style={{ color: "#7BC8FF" , cursor: "pointer" }}></i>
              </span> :
              <span className="icon" onClick={() => { props.handleAddLike(props.data) }}>
                <i className="far fa-thumbs-up" style={{ color: "#7BC8FF" , cursor: "pointer" }}></i>
              </span>
            }

            <span>{props.data.likes.length} have liked this</span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default LikeBar;